












import { Vue, Component, Prop, Emit, Model } from 'vue-property-decorator'
import { ElementUIComponentSize } from 'element-ui/types/component'
import { ButtonType } from 'element-ui/types/button'

export interface ButtonModel {
  event: string
  text: string
  right: string
  buttonType?: ButtonType
  disabled?: boolean
  icon?: boolean
}

export interface Button extends ButtonModel {
  type: 'button'
  size?: ElementUIComponentSize
}

@Component
export default class TableColumnButton extends Vue {
  @Prop({ type: Object, required: true }) type!: Button

  get buttonClass() {
    if (this.type.icon) {
      return ['material-icons', this.$style.icon]
    } else {
      return []
    }
  }
}
